import React, { ReactElement, ReactNode } from 'react';

import useFeatureToggleService from 'feature-toggle';
import styles from './MainBlock.module.scss';
import ShadcnMainBlock from './ShadcnMainBlock';

export enum ColumnPosition {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT'
}

export interface MainBlockProps {
  title: string | ReactElement,
  titleLine2?: string | ReactElement
  headerRight?: ReactElement | string
  columnContent?: ReactNode,
  columnPosition?: ColumnPosition,
  children: ReactNode,
}

function getColumnPosition(position?: ColumnPosition): ColumnPosition {
  return position || ColumnPosition.RIGHT;
}

function LegacyMainBlock(props: MainBlockProps) {

  const columnPosition = getColumnPosition(props.columnPosition);

  const blockStyles = [
    styles.main,
    styles.block,
    props.columnContent
      ? getColumnPosition(props.columnPosition)
        .toLowerCase()
      : styles.noColumn,
  ];

  const columnElement = props.columnContent ? (
    <div
      className={`${styles.column} ${getColumnPosition(props.columnPosition)
        .toLowerCase()}`}
    >
      {props.columnContent}
    </div>
  ) : null;

  return (
    <div className={blockStyles.join(' ')}>
      {(props.headerRight || props.title) && (
        <div className={styles.header}>
          {props.headerRight && (
            <div className={styles.headerRight}>
              {props.headerRight}
            </div>
          )}
          <div className={styles.titleRow}>
            <h1>{props.title}</h1>
            {props.titleLine2 && (
              <div className={styles.line2}>
                {props.titleLine2}
              </div>
            )}
          </div>
        </div>
      )}
      <div className={styles.body}>
        {columnElement && columnPosition === ColumnPosition.LEFT ? columnElement : null}
        <div className={styles.content}>
          {props.children}
        </div>
        {columnElement && columnPosition === ColumnPosition.RIGHT ? columnElement : null}
      </div>
    </div>
  );
}

function MainBlock(props: MainBlockProps) {
  const { isShadcnUiEnabled } = useFeatureToggleService();

  if (isShadcnUiEnabled()) {
    return <ShadcnMainBlock {...props} />;
  } else {
    return <LegacyMainBlock {...props} />;
  }
}

export default MainBlock;
